<template>
  <PostHeader :story="story" :myProfileId="myProfileId" :slider="0" v-model:description="description"
    :piklistId="piklistId" :imageId="pik_id" :piklist_user_id="piklist_user_id" :storefront="storefront"
    :piklist_profile_pic="piklist_profile_pic" :user_id="user_id" :user_name="user_name" :pikd_pik_id="pikd_pik_id"
    :piklist_fullname="piklist_fullname" :piklist_userbadge="piklist_userbadge" :piklist_ecbbadge="piklist_ecbbadge" :piklist_username="piklist_username"
    :originator_id="originator_id" :originator_username="originator_username" :isAd="isAd" :date_time="date_time"
    v-model:visibility="visibility" v-model:piklist_name="piklist_name" :post_address="post_address" />
  <swiper-container
    v-if="story != null && (Object.keys(story.allimages).length > 1 || story.allimages[0].type != 3 || (story.allimages[0].type == 3 && story.allimages[0].link_url != ''))"
    @swiperslidechange="slideChanged('storySlider' + story.piklist_id)" :id="'storySlider' + story.piklist_id"
    :ref="'storySlider' + story.piklist_id" :initialSlide="calcFirstSlide()" no-swiping-selector=".vjs-control-bar"
    :virtual="{ enabled: true }" :nested="true"
    :navigation="{ nextEl: '.swiper-button-next-' + getPaginationId(), prevEl: '.swiper-button-prev-' + getPaginationId() }">
    <swiper-slide v-for="(image, itemIndex) in story.allimages"
      :key="'imagekey-' + image.id + '-' + streamIndex + '-' + piklistId"
      :virtualIndex="'imagekey-' + image.id + '-' + streamIndex + '-' + piklistId"
      :id="'imagekey-' + image.id + '-' + streamIndex + '-' + itemIndex" @touchmove.passive="registerView(itemIndex)"
      @mouseover="registerView(itemIndex)">
      <div v-if="(current_index + 1 != 1) && itemIndex == 0" data-role="none" @click="loadMoreImages(image.id)"
        :class="'swiper-loadmore-prev-cs loadmore-' + story.piklist_id + '_' + current_index" role="button"><span>{{
          $t("buttons.loadmore") }}</span>
      </div>
      <div v-if="itemIndex + 1 == Object.keys(story.allimages).length && getImageIndex(pik_id) != (totalpiks + totalvids)"
        @click="loadMoreImages(image.id)"
        :class="'swiper-loadmore-next-cs loadmore-' + story.piklist_id + '_' + current_index" role="button"><span>{{
          $t("buttons.loadmore") }}</span>
      </div>
      <div v-if="story.isPremium == 'yes' && story.canViewPremium == 'no'" :style="'background-image:url(\'' + path + '/piks/' + image.pik_name + '\');'
        " class="subscriber-background"></div>
      <div @click="openBuyModal(user_id)"
        v-if="story.isPremium == 'yes' && story.canViewPremium == 'no' && !checkIosApp()" class="subscriber-bg-text">
        <h1>{{ $t("buttons.premiumstory") }}</h1>
        <p>{{ $t("buttons.clickhere") }}</p>
      </div>
      <div v-if="story.isPremium == 'yes' && story.canViewPremium == 'no' && checkIosApp()" class="subscriber-bg-text">
        <h1>{{ $t("buttons.premiumstory") }}</h1>
        <p>&nbsp;</p>
      </div>
      <div style="position: relative;" v-if="image.type == 1 ||
        (image.type == 2 &&
          showPlayer.indexOf('videoPlayer' + image.id + '_' + streamIndex) == -1 && image.encoder!=null) || (image.type == 3 &&
            image.link_url != '' &&
            image.link_url != null &&
            image.link_image != '' &&
            image.link_image != null &&
            showPlayer.indexOf('linkPlayer' + image.id + '_' + streamIndex) == -1)
        ">

        <img :class="calculateImageAspectRatio(story, image) + ' photo-image-' + image.id + ' click'"
          :id="'image_' + image.id" :src="path + '/piks/' + image.pik_name" loading="lazy"
          @click="didClick(story.isAd, image)" />
        <div class="video-play" v-if="image.type == 2"
          v-show="showPlayer.indexOf('videoPlayer' + image.id + '_' + streamIndex) == -1"
          @click="setVideoOptions(image.pik_name, 'videoPlayer' + image.id + '_' + streamIndex, false)">
          <ion-icon class="video-play-icon" :icon="play"></ion-icon>
        </div>
        <div class="video-play"
          v-if="image.link_video != '' && image.link_video != null && showPlayer.indexOf('linkPlayer' + image.id + '_' + streamIndex) == -1"
          @click="setVideoOptions(image.link_video, 'linkPlayer' + image.id + '_' + streamIndex, true)">
          <ion-icon class="video-play-icon" :icon="play"></ion-icon>
        </div>
        <div class="swiper-lazy-preloader"></div>
      </div>
      <div class="slider-feature-img-sq ion-text-center" v-if="image.type==2 && image.encoder==null">
        <div class="slider-center-txt" v-html="'<h3>Video processing underway.</h3><p>Check back shortly!</p>'"></div>
      </div>
      <div :class="calculateImageAspectRatio(story, image)" v-show="(image.type == 3 &&
        (image.link_url == '' ||
          image.link_url == null) &&
        (image.link_image == '' ||
          image.link_image == null))">
        <div class="slider-center-txt" v-html="image.description"></div>
      </div>
      <div :class="calculateImageAspectRatio(story, image) + ' click'" v-show="(image.type == 3 &&
        (image.link_url != '' &&
          image.link_url != null) &&
        (image.link_image == '' ||
          image.link_image == null))" @click="didClick(story.isAd, image)">
          <div class="slider-center-txt" style="text-decoration: underline;">{{ image.link_url }}</div>
      </div>
      <div v-if="image.type == 2"
        v-show="parseInt(showPlayer.indexOf('videoPlayer' + image.id + '_' + streamIndex)) > -1">
        <video :class="'video-js vjs-default-skin ' + calculateAspectRatio(image)" :width="image.width"
          :height="image.height" :ref="'videoPlayer' + image.id + '_' + streamIndex"
          :id="'videoPlayer' + image.id + '_' + streamIndex" :poster="path + '/piks/' + image.pik_name"
          playsinline></video>
      </div>
      <div v-if="image.link_video != '' && image.link_video != null">
        <div v-show="parseInt(showPlayer.indexOf('linkPlayer' + image.id + '_' + streamIndex)) > -1">
          <video v-if="!isEmbed(image.link_video)" class="video-js vjs-default-skin vjs-fluid"
            :ref="'linkPlayer' + image.id + '_' + streamIndex" :id="'linkPlayer' + image.id + '_' + streamIndex"
            :poster="image.link_image" playsinline></video>
          <iframe :style="'width:100%; ' + videoIframeAspect(story, image)" v-if="isEmbed(image.link_video)"
            :src="image.link_video"></iframe>
        </div>

      </div>
    </swiper-slide>
  </swiper-container>
  <ion-grid>
    <ion-row>
      <ion-col size="3">
        <button type="button" style="float:left;" :class="'swiper-buttons swiper-button-prev-' + getPaginationId()">
          <ion-icon :icon="chevronBackOutline"></ion-icon>
        </button>
      </ion-col>
      <ion-col size="6" style="left:0; transform: translateX(20%);  margin-top:16px;"
       >
      </ion-col>
      <ion-col size="3">
        <button style="float:right;" :class="'swiper-buttons swiper-button-next-' + getPaginationId()" type="button">
          <ion-icon :icon="chevronForwardOutline"></ion-icon>
        </button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div v-if="type == 3 &&
    link_url != '' &&
    link_url != null &&
    link_image != '' &&
    link_image != null" 
    class="url-block-small"
    @click="openLink(link_url)">
    <ion-grid class="ion-padding">
        <ion-row class="ion-align-items-center">
          <ion-col class="ion-no-padding">
            <ion-icon style="color: rgba(140, 140, 140, 1.0); float:left;" :icon="link"></ion-icon> 
            <div class="link" >{{ getHostName(link_url) }}</div>
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center">
          <ion-col class="ion-no-padding">
            <div class="link_text" v-show="link_text != ''">{{ link_text }}</div>
          </ion-col>
        </ion-row>
      </ion-grid>
  </div>
  <div 
    v-if="(pikd_pik_id == 0 || pikd_pik_id == null) && checkPremium() && checkLink(type, link_url, link_image)">
    <PostDescription :description="description" :piklist_id="piklistId" :pik_id="pik_id" :pikd_pik_id="pikd_pik_id"
      :originator_id="originator_id" :originator_username="originator_username" :current_index="current_index"
      slider="1" />
  </div>
  <div class="repost-box" style="margin-top:0; border-radius: 0px 0px 8px 8px;"
    v-if="(pikd_pik_id != 0 && pikd_pik_id != null)">
    <PostHeader :story="story" :myProfileId="myProfileId" :slider="0" v-model:description="description"
      :piklistId="piklistId" :imageId="pik_id" :piklist_user_id="piklist_user_id" :storefront="storefront"
      :piklist_profile_pic="piklist_profile_pic" :user_id="user_id" :user_name="user_name" :pikd_pik_id="pikd_pik_id"
      :piklist_fullname="piklist_fullname" :piklist_userbadge="piklist_userbadge" :piklist_ecbbadge="piklist_ecbbadge" :piklist_username="piklist_username"
      :originator_id="originator_id" :originator_username="originator_username" :isAd="isAd" :date_time="date_time"
      v-model:visibility="visibility" piklist_name="" :repost="true" :post_address="post_address" />
    <PostDescription
      v-if="(pikd_pik_id != 0 && pikd_pik_id != null) && checkPremium() && type != 3 || (type == 3 && link_url != '') || (type == 3 && Object.keys(story.allimages).length == 1)"
      :description="description" :piklist_id="piklistId" :pik_id="pik_id" :pikd_pik_id="pikd_pik_id"
      :originator_id="originator_id" :originator_username="originator_username" :current_index="current_index"
      slider="1" />
  </div>
  <div style="padding-top: 5px; padding-bottom: 5px; background: none"
    v-if="(link_url != '' && link_url != null) && (link_url.search('.mp3') != -1 || link_url.search('.m4a') != -1)">
    <audio ref="audioPlayer" style="display: block; width: 90%; margin-left: auto; margin-right: auto;" controls>
      <source :src="link_url" type="audio/mpeg" />
      {{ $t("alertmessage.unsupported") }}
    </audio>
  </div>
  <PostFooter :story="story" :totalpiks="totalpiks" :totalvids="totalvids" v-model:likeittype="likeittype"
    v-model:likeit="likeit" v-model:likes="likes" v-model:totalcomments="totalcomments" v-model:numberFav="numberFav"
    v-model:watching="watching" v-model:numberRepost="numberRepost" v-model:link_url="link_url"
    v-model:link_image="link_image" v-model:link_text="link_text" :isAd="story.isAd" :type="type"
    :numberViews="numberViews" :current_index="current_index" :pik_id="pik_id" slider="1" />
</template>
<script>
import { defineComponent } from "vue";
import { modalController, loadingController, IonIcon, isPlatform, IonGrid, IonCol, IonRow } from '@ionic/vue';
import getEnv from "@/utils/env";
import {
  play,
  chevronForwardOutline,
  chevronBackOutline,
  link
} from "ionicons/icons";

import videojs from "video.js/dist/video.min.js";
import "video.js/dist/video-js.min.css";
import PostDescription from "@/components/PostDescription.vue";
import PostHeader from "@/components/PostHeader.vue";
import PostFooter from "@/components/PostFooter.vue";
import BuyModal from '@/components/BuyModal.vue'
import PhotoView from '@/components/PhotoView.vue'
import { Browser } from '@capacitor/browser';

export default defineComponent({
  name: "SliderContainer",
  emits: ['update:story'],
  props: {
    streamName: String,
    filter: String,
    userid: Number,
    story: { Object, default: null },
    streamIndex: Number,
    myProfileId: { Number, default: 0 },
    //refocus: { Number, default: 0 },
    imageSelected: { Number, default: 0 }
  },
  components: {
    //Swiper,
    //SwiperSlide,
    PostDescription,
    IonIcon,
    PostHeader,
    PostFooter,
    IonGrid, IonCol, IonRow
  },
  setup() {
    return { play, chevronForwardOutline, chevronBackOutline, link };
  },
  data() {
    return {
      showPlayer: [],
      player: [],
      loading: true,
      loadingIndicator: { Object, default: null },
      pagingloading: null,
      path: getEnv("AWS_URL") + getEnv("PHOTO_BUCKET"),
      link_url: '',
      link_text: '',
      link_image: '',
      link_video: '',
      featured_pik_id: this.story.pik_id,
      pik_id: this.story.pik_id,
      description: '',
      current_index: this.story.current_index,
      piklistId: this.story.piklist_id,
      piklist_user_id: this.story.piklist_user_id,
      storefront: this.story.storefront,
      piklist_profile_pic: this.story.piklist_profile_pic,
      user_id: this.story.piklist_user_id,
      pikd_pik_id: '',
      piklist_fullname: this.story.piklist_fullname,
      piklist_userbadge: this.story.piklist_userbadge,
      piklist_ecbbadge: this.story.piklist_ecbbadge,
      piklist_username: this.story.piklist_username,
      originator_id: '',
      originator_username: '',
      isAd: this.story.isAd,
      date_time: '',
      visibility: this.story.visibility,
      piklist_name: this.story.piklist_name,
      pik_name: '',
      pik_path: '',
      origin_date: '',
      width: '',
      height: '',
      totalcomments: '',
      likes: '',
      cute: '',
      lol: '',
      loveit: '',
      greatshot: '',
      cool: '',
      dislike: '',
      wow: '',
      likeit: '',
      likeittype: '',
      numberRepost: '',
      numberViews: '',
      numberFav: this.story.numberFav,
      watching: this.story.watching,
      totalpiks: this.story.totalpiks,
      totalvids: this.story.totalvids,
      user_name: '',
      type: '',
      paginationId: 0,
      post_address: ''
    };
  },
  /* beforeUnmount() {
     //console.log('umounted slidercontainer');
     let storySliderRef = 'storySlider' + this.story.piklist_id;
     var slider = this.$refs[storySliderRef].swiper;
     //console.log(slider);
     slider.destroy();
   }, */
  mounted() {
    let currentImage;
    for (var i = 0; i < this.story.allimages.length; i++) {
      if (this.story.allimages[i].current_index == this.current_index) {
        currentImage = this.story.allimages[i];
      }
    }

    if (currentImage != undefined) {
      this.pik_name = currentImage.pik_name;
      this.description = currentImage.description;
      this.width = currentImage.width;
      this.height = currentImage.height;
      this.type = currentImage.type;
      this.date_time = currentImage.date_time;
      this.link_url = currentImage.link_url;
      this.link_text = currentImage.link_text;
      this.link_image = currentImage.link_image;
      this.link_video = currentImage.link_video;
      this.pikd_pik_id = currentImage.pikd_pik_id;
      this.post_address = currentImage.post_address;
      this.getImageData(currentImage);

      if(this.$route.name=="story" || this.$route.name=="storyview"){
        let video = '';
        let title;
        let user = this.piklist_fullname;
        title = user + ' on ' + getEnv('APP_NAME') + ': ' + this.description.substring(0, 40) + "...";
        if (this.type == 2) {
          video = getEnv("AWS_URL") + getEnv("VIDEO_BUCKET") + "/" + this.pik_name.slice(0, -4) + "/video.m3u8";
        }
        //console.log(this.pik_id, 'pik_id');
        this.$store.dispatch("header/custom", {
          title: title,
          description: this.description,
          url: 'https://' + getEnv('SHARE_HOSTNAME') + this.$route.fullPath,
          pik_name: this.path + '/piks/' + this.pik_name,
          width: this.width,
          height: this.height,
          video: video,
          id: this.pik_id
        });
      }
    }
  },
  methods: {
    calcFirstSlide() {
      let firstIndex = this.story.allimages.length;
      for (var i = 0; i < this.story.allimages.length; i++) {
        //console.log(this.story.allimages[i].id);
        //console.log(this.story.allimages[i].id + ":" + this.pik_id);
        if (this.story.allimages[i] != null && this.featured_pik_id == this.story.allimages[i].id) {
          firstIndex = i;
        }
      }
      return firstIndex;
    },
    calculateAspectRatio(video) {
      /*let index = 0;
      for (var i = 0; i < this.story.allimages.length; i++) {
        if (this.story.allimages[i] != null && this.featured_pik_id == this.story.allimages[i].id) {
          index = i;
        }
      }
      console.log(index, 'index');
      const video = story.allimages[index];*/
      //console.log(video.id, 'video id');
      //console.log(video.width + 'width, ' + video.height + ' height', 'video');
      var aspectClass = "vjs-fluid";
      if (video.width > video.height) {
        aspectClass = "vjs-16-9";
      } else if (video.width < video.height) {
        aspectClass = "vjs-9-16";
      } else if (video.width == video.height) {
        aspectClass = "vjs-1-1";
      }
      //console.log(aspectClass, 'class');
      return aspectClass;
    },
    videoIframeAspect(story) {
      let index = 0;
      for (var i = 0; i < this.story.allimages.length; i++) {
        if (this.story.allimages[i] != null && this.featured_pik_id == this.story.allimages[i].id) {
          index = i;
        }
      }
      //console.log(index, 'index');
      const image = story.allimages[index];

      var aspectRatio = "aspect-ratio: 1 / 1 ;";
      if (image.width > image.height) {
        aspectRatio = "aspect-ratio: 16 / 9 ;";
      }
      return aspectRatio;
    },
    calculateImageAspectRatio(story, current_image) {
      let index = 0;
      for (var i = 0; i < this.story.allimages.length; i++) {
        if (this.story.allimages[i] != null && this.featured_pik_id == this.story.allimages[i].id) {
          index = i;
        }
      }
      //console.log(index, 'index');
      const image = story.allimages[index];
      var aspectClass = "slider-feature-img-sq";

      if (image.width > image.height) {
        aspectClass = "slider-feature-img-wd";
      } else if (image.width == 0 && image.type == 3) {
        aspectClass = "slider-feature-img-wd";
      } /*else if (image.width < image.height) {
        aspectClass = "slider-feature-img-vt";
      }  else if (image.width == image.height) {
        aspectClass = "vjs-1-1";
      }*/
      if (image.type == 3 &&
        (image.link_url == '' ||
          image.link_url == null) &&
        (image.link_image == '' ||
          image.link_image == null)) {
        aspectClass = "slider-feature-img-wd";
      }
      if (current_image.type == 3 && current_image.link_url != '' && current_image.link_url != undefined) {
        aspectClass = aspectClass + ' ' + 'rounded-edge';
      }
      return aspectClass;
    },
    calcVideoHeight(video) {
      var height = (video.height * 100) / video.width;
      height = video.width / 2 + "px";
      if (video.width == video.height) {
        height = video.height + "px";
      }
      return height;
    },
    /* clearReadMore(){
      //console.log('set clear read more');
      this.clearMore = 1;
      this.$emit('update:refocus', this.story.pik_id);   
    },*/
    async slideChanged(storySliderRef) {
      if (this.$refs[storySliderRef] == null) {
        return;
      }
      //console.log('slide changed');
      var slider = await this.$refs[storySliderRef].swiper;
      let activeIndex = await slider.activeIndex;

      if (this.story != undefined && activeIndex != undefined) {
        //console.log(activeIndex, 'slider index');
        let sliderImage = this.story.allimages[activeIndex];
        this.setFeaturedImage(sliderImage);
        this.pauseAllVideos();
        this.totalcomments = '';
        this.likes = '';
        this.cute = '';
        this.lol = '';
        this.loveit = '';
        this.greatshot = '';
        this.cool = '';
        this.dislike = '';
        this.wow = '';
        this.likeit = '';
        this.likeittype = '';
        this.numberRepost = '';
        this.numberViews = '';
        this.getImageData(sliderImage);
      }
    },
    async loadMoreImages(id) {
      this.$router.push({ name: 'story', params: { imageid: id } });
    },
    async pauseAllVideos() {
      //console.log('pausing all');
      //console.log(this.player);
      for (var i = 0; i < this.player.length; i++) {
        //console.log(this.player[i]);
        this.player[i].pause();
      }
    },
    setVideoOptions(fileName, videoPlayerRef, isLink) {
      if (isLink) {
        if (this.isEmbed(fileName)) {
          this.showPlayer.push(videoPlayerRef);
          return;
        }
      }

      for (var i = 0; i < this.player.length; i++) {
        //console.log(this.player[i].id_);
        if (this.player[i].id_ == videoPlayerRef) {
          return;
        }
      }
      if (this.$refs[videoPlayerRef] == null) {
        return;
      }
      //console.log(this.player);
      this.showPlayer.push(videoPlayerRef);
      //console.log('add new player ' + this.showPlayer);
      let videoType = "application/x-mpegURL";
      let file =
        getEnv("AWS_URL") +
        getEnv("VIDEO_BUCKET") +
        "/" +
        fileName.slice(0, -4) +
        "/video.m3u8";

      if (isLink) {
        if (this.isEmbed(fileName)) {
          console.log('test');
          return;
        }
        //console.log(fileName.slice(-4));
        //let fileExtension = fileName.slice(-4);
        if (fileName.search(".mp4") != -1) {
          videoType = "video/mp4";
        } else if (fileName.search(".m3u8") != -1) {
          videoType = "application/x-mpegURL";
        } else if (fileName.search(".mov") != -1) {
          videoType = "video/quicktime";
        } else if (fileName.search(".flv") != -1) {
          videoType = "video/x-flv";
        }
        file = fileName;
      }
      //https://content1.avplayer.com/608b27d947d2c37558214754/videos/64246690ad0c3d48600f9fa3/6424669436520f9f800555b4/video.mp4?AV_TAGID=608bfd1f328b2f32b531a418&pid=608b27d947d2c37558214754&cid=608bfb364d75bb076f014ab7&AV_TEMPID=608bfc71ca4a77573a66adc7&AV_PUBLISHERID=608b27d947d2c37558214754&av_qd1=637fb2ac72eed618ed005b52&videoId=64246690ad0c3d48600f9fa3
      //console.log(videoType);
      //console.log(file);
      var options = {
        autoplay: true,
        controls: true,
        nativeControlsForTouch: true,
        /* controlBar: {
          volumePanel: {
            dimension: [0, 0]
          }
        }, 
        liveui: true, */
        preload: "auto",
        mute: true,
        //loop: true,
        sources: [
          {
            src: file,
            type: videoType
          },
        ],
      };

      videojs.addLanguage("en", {
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "This Video is processing and may take a few minutes.",
      });
      //var slider = this.$refs[storySliderRef].$el.swiper;
      //console.log(this.$refs[videoPlayerRef]);
      this.player.push(
        videojs(
          this.$refs[videoPlayerRef][0],
          options,
          function onPlayerReady() {
            //console.log('onPlayerReady', this);
            //console.log('controlBar', this['controlBar']);
            //this['controlBar']['durationDisplay'].hide();
            //slider.updateSize();
          }
        )
      );
    },
    setFeaturedImage(sliderImage) {
      if (sliderImage != undefined) {
        //console.log(sliderImage);
        this.pik_id = sliderImage.id;
        this.pik_name = sliderImage.pik_name;
        this.description = sliderImage.description;
        this.width = sliderImage.width;
        this.height = sliderImage.height;
        this.type = sliderImage.type;
        this.date_time = sliderImage.date_time;
        this.link_url = sliderImage.link_url;
        this.link_text = sliderImage.link_text;
        this.link_image = sliderImage.link_image;
        this.link_video = sliderImage.link_video;
        this.pikd_pik_id = sliderImage.pikd_pik_id;
        this.current_index = sliderImage.current_index;
        this.post_address = sliderImage.post_address;
      }
    },
    async presentLoading(message) {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: message,
        });
      await this.loadingIndicator.present();
    },
    async getImageData(sliderImage) {
      if (sliderImage == null || sliderImage.id == null) {
        return;
      }
      let response = await this.$store.dispatch("pikstream/imageData", {
        url: "pikstream/stream-image?id=" + this.story.piklist_id + "&image_id=" + sliderImage.id
      });
      if (response) {
        if (response.error != undefined) {
          //this.loadingIndicator.dismiss();
          console.log('Error: ' + response.error);
        } else {
          //console.log(response, 'story');
          /* let title = this.story.piklist_name;
          if(title=='') title = getEnv('APP_NAME');
          this.$store.dispatch("header/custom", {
            title: title,
            description: response.description,
            url: 'https://' + getEnv('SHARE_HOSTNAME') + '/story/' + this.pik_id,
            pik_name: this.path + '/piks/' + this.pik_name,
            width: this.width,
            height: this.height 
          }); */
          //console.log(response, 'response');
          this.pik_path = response.pik_path;
          this.origin_date = response.origin_date;
          this.description = response.description;
          this.totalcomments = response.totalcomments;
          this.likes = response.likes;
          this.cute = response.cute;
          this.lol = response.lol;
          this.loveit = response.loveit;
          this.greatshot = response.greatshot;
          this.cool = response.cool;
          this.dislike = response.dislike;
          this.wow = response.wow;
          this.likeit = response.likeit;
          this.likeittype = response.likeittype;
          this.numberRepost = response.numberRepost;
          this.numberViews = response.numberViews;
          this.originator_id = response.originator_id;
          this.originator_username = response.originator_username;
          this.user_id = response.user_id;
          this.user_name = response.user_name;
          this.pikd_pik_id = response.pikd_pik_id;
          //this.type = response.type;
          this.link_url = response.link_url;
          this.link_text = response.link_text;
          this.link_image = response.link_image;
          this.link_video = response.link_video;
        }
      }
    },
    async hideButtons(itemIndex, index) {
      var nextButtonRef = "swiper-next-" + itemIndex + "-" + index;
      var prevButtonRef = "swiper-prev-" + itemIndex + "-" + index;
      var nextButton = this.$refs[nextButtonRef];
      var prevButton = this.$refs[prevButtonRef];
      //console.log(nextButton, 'next-hide');
      //console.log(prevButton, 'prev-hide');

      if (nextButton != null && nextButton[0] != null)
        nextButton[0].style.display = "none";
      if (prevButton != null && prevButton[0] != null)
        prevButton[0].style.display = "none";
      //console.log('hide buttons ' + index);
    },
    async showButtons(itemIndex, index) {
      var nextButtonRef = "swiper-next-" + itemIndex + "-" + index;
      var prevButtonRef = "swiper-prev-" + itemIndex + "-" + index;
      var nextButton = this.$refs[nextButtonRef];
      var prevButton = this.$refs[prevButtonRef];
      //console.log(nextButton, 'show-next');
      //console.log(prevButton, 'show-prev');
      if (nextButton != null && nextButton[0] != null)
        nextButton[0].style.display = "block";
      if (prevButton != null && prevButton[0] != null)
        prevButton[0].style.display = "block";
      // console.log('show buttons ' + index);
      this.registerView(itemIndex);
    },
    /* async refreshSliderHeight() {
      let storySliderRef = 'storySlider' + this.story.piklist_id;
      if (await this.$refs[storySliderRef].swiper != null) {
        console.log('refreshing height');
        let slider = await this.$refs[storySliderRef].swiper;
        await slider.updateAutoHeight(5000);
      }
      this.heightRefresh = 0;
    },*/
    async goToFeaturedImage() {
      //console.log( this.$route.name, 'checking go to');
      if (this.imageSelected != 0 && (this.$route.name == 'story' || this.$route.name == 'storyview')) {
        //console.log("selected");
        //console.log(this.imageSelected, 'slide image id');
        //console.log(this.story.allimages, 'story images');
        let newIndex = 0;
        for (var i = 0; i < Object.keys(this.story.allimages).length; i++) {
          if (this.story.allimages[i] != null && this.story.allimages[i].id == this.imageSelected) {
            newIndex = i;
          }
        }
        //console.log(newIndex, 'new index');
        //let storySliderRef = "storySlider" + this.index;
        let storySliderRef = "storySlider" + this.story.piklist_id;
        //console.log(storySliderRef, 'story ref');
        var slider = await this.$refs[storySliderRef].swiper;
        //console.log(slider);
        slider.slideTo(newIndex, 500);
        //this.$emit('update:refocus', this.story.pik_id);
      }
    },
    prevFeaturedImage(storySliderRef) {
      var slider = this.$refs[storySliderRef].swiper;
      //console.log(slider);
      this.clearReadMore()
      slider.slidePrev(500);
    },
    nextFeaturedImage(storySliderRef) {
      var slider = this.$refs[storySliderRef].swiper;
      //console.log(this.$refs[storySliderRef].$el.swiper);
      this.clearReadMore()
      slider.slideNext(500);
    },
    /* resetPlayers() {
      if (this.$store.state.helpers.reloadStream == "Y") {
        //console.log("reset players");
        this.player = [];
        this.$store.commit("helpers/setReloadStream", "N");
      }
    }, */
    showZoom(type) {
      let zoomClass = '';
      if (type == 1) {
        zoomClass = 'swiper-zoom-container';
      }
      return zoomClass;
    },
    getImageIndex(imageId) {
      var itemIndex = 0;
      //if (storyImageIndex == null) {
      var currentImages = this.story.allimages;
      for (var i = 0; i < currentImages.length; i++) {
        if (currentImages[i].id == imageId) {
          itemIndex = parseInt(currentImages[i].current_index);
        }
      }
      /* } else {
        itemIndex = parseInt(storyImageIndex);
      }*/
      return itemIndex + 1;
    },
    /* getImageIndex(imageId, totalpiks, totalvids, storyImageIndex) {
      //console.log(imageId, 'imageId');
      //console.log(storyIndex, 'storyIndex');
      //console.log(this.current_index + ': ' +storyImageIndex, 'storyImageIndex');
      //console.log(this.story.allimages.length + ' : ' + totalpiks+totalvids, 'total posts');
      
      var itemIndex = 0;
      if (storyImageIndex == null) {
        //var selectedStories = this.stories;
        //if(this.$route.name=="profile"){
        //  selectedStories = this.profileStories;
        //}else if(this.$route.name=="myprofile"){
        //  selectedStories = this.myProfileStories;
        //}
        //var currentImages = this.stories[storyIndex].allimages;
        var currentImages = this.story.allimages;

        for (var i = 0; i < currentImages.length; i++) {
          if (currentImages[i].id == imageId) {
            itemIndex = parseInt(currentImages[i].current_index);
          }
        }
      } else {
        itemIndex = parseInt(storyImageIndex);
      }
      //console.log(itemIndex + 1, 'itemindex')
      return itemIndex + 1;
    },
    adClick(isAd) {
      if (isAd) {
        return "ad-click";
      } else {
        return "";
      }
    },*/
    registerView(itemIndex) {
      //console.log('registering view');
      //var sliderImage = this.stories[index].allimages[itemIndex];
      var sliderImage = this.story.allimages[itemIndex];

      // console.log(sliderImage.id);
      this.$store.commit("helpers/setViews", [null, sliderImage.id]);

      //console.log(this.$store.state.helpers.viewsTimestamp);
      //console.log(Date.now());
      var difference =
        (Date.now() - this.$store.state.helpers.viewsTimestamp) / 1000;
      //console.log('diff: ' + difference);
      if (difference > 60) {
        this.$store.dispatch("helpers/postViews");
        //console.log('one minute passed');
      }
    },
    async didClick(isAd, image) {
      if (isAd == "Y") {
        if (image.link_url != "" && image.link_url != undefined) {
          await Browser.open({ url: image.link_url }); 
          //window.open(image.link_url, '_blank');
        }
      } else if (image.type == 1) {
        this.openFullScreen(this.path + '/piks/' + image.pik_name, image.width, image.height);
      } else if (image.type == 3 && image.link_video == '') {
        this.openLink(image.link_url);
      }
      return;
    },
    async openLink(link_url) {
      if (link_url != '') {
        await Browser.open({ url: link_url }); 
        //window.open(link_url, '_blank');
      }
    },
    async openLinkVideo(link_url, isVideo) {
      if (link_url != '' && !isVideo) {
        await Browser.open({ url: link_url }); 
        //window.open(link_url, '_blank');
      }
    },
    getHostName(url) {
      var match = '';
      if (url != '' && url != undefined) {
        match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      }
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      } else {
        return null;
      }
    },
    async openBuyModal(user_id) {
      if (this.$store.state.auth.token != '') {
        await this.presentLoading(this.$t('loadmessage.loading'));
        let profileData = await this.$store.dispatch("profile/otherUserInfo", { userId: user_id });
        //console.log(profileData, 'profile data');
        if (profileData != null) {
          let profile = this.$store.state.profile.profilePageData[user_id];
          let title = this.$t('buttons.premiumcontent');
          let isMyProfile = false;
          if (profile.id == this.$store.state.profile.id) {
            isMyProfile = true;
          }
          this.loadingIndicator.dismiss();
          const modal = await modalController
            .create({
              component: BuyModal,
              cssClass: 'modal-custom-class',
              componentProps: {
                title: title,
                //user_id: user_id
                profile: profile,
                isMyProfile: isMyProfile
              }
            })
          await modal.present();
          const { role } = await modal.onDidDismiss();
          //console.log(role);
          if (role == "subscribed") {
            //console.log('subscribed');
            this.$router.push({ name: 'profile', params: { id: user_id } });
          }
        }
      }
    },
    checkPremium() {
      let canView = true;
      if (this.story.isPremium == 'yes' && this.story.canViewPremium == 'no') {
        canView = false;
      }
      return canView;
    },
    checkIosApp() {
      let iosCheck = false;
      if (isPlatform('hybrid') && isPlatform('ios')) {
        iosCheck = true;
      }
      return iosCheck;
    },
    checkLink(type, link_url, link_image) {
      if (type == 3) {
        if ((link_url == '' ||
          link_url == null) &&
          (link_image == '' ||
            link_image == null)) {
          return false;
        }
        let cleanedText = this.description.replace(/(<([^>]+)>)/gi, " ");
        let cleanedText2 = this.link_text.replace(/(<([^>]+)>)/gi, " ");
        if (cleanedText.trim().length != cleanedText2.trim().length) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isTextOnly() {
      let textOnly = 0;
      if (this.type == '3' && this.link_url == '') {
        textOnly = 1;
      }
      return textOnly;
    },
    isEmbed(link) {
      let position = link.toLowerCase().search("/embed/");
      let youtubeLink = false;
      if (position != -1) {
        youtubeLink = true;
      }
      return youtubeLink;
    },
    linkVideoCheck(link_video, playerIndex) {
      let canShow = true;
      if (link_video != '' && link_video != null) {
        if (this.isEmbed(link_video)) {
          canShow = false;
        } else if (this.showPlayer.indexOf(playerIndex) > -1) {
          canShow = false;
        }
      }
      return canShow;
    },
    getPaginationId() {
      if (this.paginationId == 0) {
        if (this.$route.name == 'story' || this.$route.name == 'storyname' || this.$route.name == 'profile') {
          this.paginationId = Math.floor(Math.random() * 1000);
        } else {
          this.paginationId = this.streamIndex + '-' + this.$route.name;
        }
      }
      //console.log(this.paginationId, 'page id');
      return this.paginationId;
    },
    async openFullScreen(image, width, height) {

      const modal = await modalController
        .create({
          component: PhotoView,
          cssClass: 'fullscreen',
          componentProps: {
            image_id: this.pik_id,
            image: image,
            width: width + 'px',
            height: height + 'px'
          }
        })
      await modal.present();

      //const { role } = await modal.onDidDismiss();
      //console.log(role);
    },
  },
  watch: {
    imageSelected() {
      this.goToFeaturedImage();
    },
    /* heightRefresh() {
      //console.log('update height');
      this.refreshSliderHeight();
    }*/
  }
});
</script>
<style scoped>
.swiper-buttons {
  background-color: var(--ion-item-background);
  font-size: 26px;
  color: var(--ion-color-primary);
}

.swiper-button-disabled {
  opacity: 0.5;
}

.swiper-button-prev-cs,
.swiper-button-next-cs {
  display: none;
  position: absolute;
  background-image: none;
  margin-left: 10px;
  content: "";
  /* top: 50%; */
  top: 0px;
  /* -ms-transform: translateY(-50%);
  transform: translateY(-50%); */
  cursor: pointer;
  background-color: rgba(180, 180, 180, 0.4);
  z-index: 9999;
  height: 44px;
  width: 24px;
  padding-top: 10px;
  border-radius: 5px;
  /* color: white; */
}

.swiper-button-next-cs {
  right: 0;
  margin-right: 10px;
}
.swiper-hide {
  display: none;
}

.swiper-loadmore-prev-cs,
.swiper-loadmore-next-cs {
  /* position: absolute; */
  position: fixed;
  bottom: 5px;
  background-image: none;
  margin-left: 10px;
  content: "";
  /* top: 50%; 
  top: 0px; */
  /* -ms-transform: translateY(-50%);
  transform: translateY(-50%); */
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.4);
  border: 1px solid white;
  z-index: 9999;
  height: 44px;
  width: 100px;
  padding-top: 10px;
  border-radius: 5px;
  text-align: center;
  /* color: white; */
}

.swiper-loadmore-next-cs {
  position: absolute;
  right: 7px;
}

.swiper-loadmore-prev-cs span,
.swiper-loadmore-next-cs span {
  font-size: 0.9em;
  font-weight: bolder;
  color: white;
}

/*.swiper-button-prev{
    position: absolute;
    bottom: 0;
    left: 0;
    float:left;
    margin-left: -50px;
    margin-top: 95%;
    }

     .swiper-button-next{

    } */
.swiper-container {
  --swiper-navigation-size: 0;
}

.video-js .vjs-icon-next-item {
  font-size: 18px;
}

.video-js .vjs-big-play-button {
  width: 0px;
  height: 0px;
  display: none;
}
</style>
